import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class PhonecallService {
  private url = 'phonecalls';

  constructor(private httpClient: HttpClientService) {}

  /**
   * Get list of phonecalls
   * @param  {any       = {}}        params Index params
   * @return {Promise<any>}   JSON response from server
   */
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  /**
   * Get search select field lists and default options from index action
   * @return {Promise<any>} Response with search options
   */
  searchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { search_options: true });
  }
}
